import Vue from 'vue'
import Router from 'vue-router'
import { apolloClient } from './vue-apollo'
import { VERIFY_ORG_BY_AGREEMENT_KEY } from './graphql/queries/organization'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import(/* webpackChunkName: "about" */ './components/User/Login2.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/Login',
      name: 'Login2',
      component: () => import(/* webpackChunkName: "about" */ './components/User/Login.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/Partners/Profile',
      name: 'Profile',
      component: () => import(/* webpackChunkName: "about" */ './components/User/Profile.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/Partners/Dashboard',
      name: 'Dashboard',
      component: () => import(/* webpackChunkName: "about" */ './components/Dashboard.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/Partners/CreatePartner',
      name: 'Create Partner',
      component: () => import(/* webpackChunkName: "about" */ './components/CreatePartner.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/Partners/Partners',
      name: 'Partners',
      component: () => import(/* webpackChunkName: "about" */ './components/Organizations.vue'),
      meta: { requiresAuth: true },
    },
    //   {
    //   path: '/Partners/ManageStock',
    //   name: 'Stock Management',
    //   component: () => import(/* webpackChunkName: "about" */ './components/ManageStock/ManageStock.vue'),
    //   meta: { requiresAuth: true },
    // },
    {
      path: '/Partners/Purchase',
      name: 'Purchase Detail',
      component: () => import(/* webpackChunkName: "about" */ './components/Stock/Purchase.vue'),
      meta: { requiresAuth: true },
    },
    // {
    //   path: '/Partners/Purchase/PurchaseOffline',
    //   name: 'Purchase Detail(Offline)',
    //   component: () => import(/* webpackChunkName: "about" */ './components/Stock/PurchaseOffline.vue'),
    //   meta: { requiresAuth: true },
    // },
    // {
    //   path: '/Partners/Purchase/PurchaseOnline',
    //   name: 'Purchase Detail(Online)',
    //   component: () => import(/* webpackChunkName: "about" */ './components/Stock/PurchaseOnline.vue'),
    //   meta: { requiresAuth: true },
    // },
    {
      path: '/Partners/Sales',
      name: 'Sales Detail',
      component: () => import(/* webpackChunkName: "about" */ './components/Stock/Sales.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/Partners/RetailSales',
      name: 'Retail Sales Detail',
      component: () => import(/* webpackChunkName: "about" */ './components/ManageStock/RetailSalesVAP.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/Partners/Stock',
      name: 'Stock Management',
      component: () => import(/* webpackChunkName: "about" */ './components/Stock/Stock.vue'),
      meta: { requiresAuth: true },
    },

    // {
    //   path: '/Partners/StockOffline',
    //   name: 'Stock Management offline',
    //   component: () => import(/* webpackChunkName: "about" */ './components/Stock/StockOffline.vue'),
    //   meta: { requiresAuth: true },
    // },

    // {
    //   path: '/Partners/Stock/StockOnline',
    //   name: 'Stock Management(Online)',
    //   component: () => import(/* webpackChunkName: "about" */ './components/Stock/StockOnline.vue'),
    //   meta: { requiresAuth: true },
    // },

    {
      path: '/Partners/Stock/Products',
      name: 'Place Online Order',
      component: () => import(/* webpackChunkName: "about" */ './components/Stock/Products.vue'),
      meta: { requiresAuth: true },
    },

    {
      path: '/Partners/Stock/Cart',
      name: 'Place Online Order',
      component: () => import(/* webpackChunkName: "about" */ './components/Stock/Cart.vue'),
      meta: { requiresAuth: true },
    },

    {
      path: '/Partners/Stock/PlaceOrder',
      name: 'Place Online Order',
      component: () => import(/* webpackChunkName: "about" */ './components/Stock/PlaceOrder.vue'),
      meta: { requiresAuth: true },
    },
    
    {
      path: '/Partners/Stock/ProductDetails',
      name: 'Product Details',
      component: () => import(/* webpackChunkName: "about" */ './components/Stock/ProductDetails.vue'),
      meta: { requiresAuth: true },
    },

    {
      path: '/Partners/Stock/OrderSummary',
      name: 'Order Summary',
      component: () => import(/* webpackChunkName: "about" */ './components/Stock/OrderSummary.vue'),
      meta: { requiresAuth: true },
    },

    {
      path: '/Partners/Stock/TransactionFailed',
      name: 'Transaction Failed',
      component: () => import(/* webpackChunkName: "about" */ './components/Stock/TransactionFailed.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/Partners/Agreement',
      name: 'Agreement',
      component: () => import(/* webpackChunkName: "about" */ './components/Agreement.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/Partners/MyLeague',
      name: 'My League',
      component: () => import('./components/MyLeague.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/Partners/Scheme',
      name: 'Scheme',
      component: () => import(/* webpackChunkName: "about" */ './components/Scheme/Schemes.vue'),
    },
    {
      path: '/Partners/DocumentCollection/:token/:applicationId',
      name: 'Document Collection',
      component: () => import(/* webpackChunkName: "about" */ './components/DocumentCollection.vue'),
    },
    {
      path: '/Partners/Links',
      name: 'Useful Links',
      component: () => import('./components/Links.vue'),
      meta: { requiresAuth: true },
    },
    /*{
      path: '/Partners/PartnerEngagementProgramme',
      name: 'ESET - Amity Program',
      component: () => import('./components/PartnerEngagementProgramme.vue'),
      meta: { requiresAuth: true },
    },*/
    {
      path: '/privacy-policy',
      name: 'Privacy Policy',
      component: () => import('./components/PrivacyPolicy'),
      meta: { requiresAuth: false },
    },
    {
      path: '/Partners/Notifications',
      name: 'Notification',
      component: () => import('./components/Notifications/Notifications.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/ReturnOrders',
      name: 'Return Orders',
      component: () => import('./components/ReturnOrder/ReturnOrders.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/Supports',
      name: 'Supports',
      component: () => import('./components/Support/Supports.vue'),
      meta: { requiresAuth: true },
    },
  ],
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    var userObj = JSON.parse(localStorage.getItem('user'))
    // const fullUrl = window.location.href;
      // localStorage.setItem('redirectAfterLogin', fullUrl);
      localStorage.setItem('redirectAfterLogin',  to.fullPath);
    if (!userObj) {
      router.replace({ path: '/' })
      return
    }
    apolloClient.query(
      {
        query: VERIFY_ORG_BY_AGREEMENT_KEY,
        variables: { id: userObj.orgId },
        fetchPolicy: 'network-only',
      },
    ).then(function (data) {
      if (data.data.Organizations.length &&
        data.data.Organizations[0].isAggrementAccepted) {
        next()
      } else {
        router.replace({ path: '/Partners/Agreement' })
      }
    }).catch(error => {
      if (error.graphQLErrors[0].message ===
        'Invalid response from authorization hook: Error in $.flag: expected Text, encountered Boolean') {
        localStorage.clear()
        router.replace({ path: '/' })
      }
    })
  } else {
    next()
  }
})

export default router